import {
    createMeterField,
    createMeterFieldValidation,
    meterValidationSchemaSuperRefine as validationSchemaSuperRefine,
} from 'constants/FormField/createMeterField'
import useFromFieldWithAccount from 'logic/useFromFieldWithAccount'

const useMeters = () => {
    const {
        fieldsCreate,
        fieldsEdit,
        isLoading: isLoadingAccount,
        validationSchema,
    } = useFromFieldWithAccount({
        fieldsCreate: createMeterField,
        fieldsEdit: createMeterField,
        validationSchema: createMeterFieldValidation,
        validationSchemaSuperRefine,
    })

    return {
        fieldsCreate,
        fieldsEdit,
        isLoading: isLoadingAccount,
        validationSchema,
    }
}

export default useMeters
